"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var PaymentsApi = function (_BaseApi) {
  (0, _inherits2["default"])(PaymentsApi, _BaseApi);

  function PaymentsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, PaymentsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(PaymentsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAccounts", function () {
      return _this.api.get("/accounts", {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createOrder", function (_ref) {
      var payload = _ref.payload;
      return _this.api.post('/order', {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOrder", function (_ref2) {
      var payload = _ref2.payload,
          orderId = _ref2.orderId;
      return _this.api.put("/order/".concat(orderId), {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createProduct", function (_ref3) {
      var payload = _ref3.payload;
      return _this.api.post('/product', {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateProduct", function (_ref4) {
      var payload = _ref4.payload,
          productId = _ref4.productId;
      return _this.api.put("/product/".concat(productId), {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteProduct", function (_ref5) {
      var productId = _ref5.productId;
      return _this.api["delete"]("/product/".concat(productId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createCoupon", function (_ref6) {
      var payload = _ref6.payload;
      return _this.api.post('/coupon', {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateCoupon", function (_ref7) {
      var payload = _ref7.payload,
          couponId = _ref7.couponId;
      return _this.api.put("/coupon/".concat(couponId), {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCouponUsers", function (_ref8) {
      var couponId = _ref8.couponId,
          clientId = _ref8.clientId,
          limit = _ref8.limit,
          next = _ref8.next;
      return _this.api.get("/coupon/".concat(couponId, "/users"), {
        params: {
          clientId: clientId,
          limit: limit,
          next: next
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCoupons", function (_ref9) {
      var clientId = _ref9.clientId,
          limit = _ref9.limit,
          skip = _ref9.skip,
          identifier = _ref9.identifier,
          sort = _ref9.sort,
          isAvailable = _ref9.isAvailable;
      return _this.api.get("/coupons", {
        params: {
          clientId: clientId,
          limit: limit,
          skip: skip,
          identifier: identifier,
          sort: sort,
          isAvailable: isAvailable
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCoupon", function (_ref10) {
      var couponId = _ref10.couponId,
          clientId = _ref10.clientId;
      return _this.api.get("/coupon/".concat(couponId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkCoupon", function (_ref11) {
      var code = _ref11.code,
          productId = _ref11.productId,
          clientId = _ref11.clientId;
      return _this.api.get("/coupon/".concat(code, "/product/").concat(productId), {
        params: {
          clientId: clientId
        }
      });
    });
    return _this;
  }

  return PaymentsApi;
}(_createApi.BaseApi);

var _default = PaymentsApi;
exports["default"] = _default;
//# sourceMappingURL=payments.js.map